const refundAnalysisStatusInfractionAPI = require('../infraction/refundAnalysisStatus');

const refundAnalysisResult = {
  totallyAccepted: 0,
  partiallyAccepted: 1,
  rejected: 2,
  convertToJDPI(status) {
    switch (status) {
      case refundAnalysisStatusInfractionAPI.TOTALLY_ACCEPTED:
        return this.totallyAccepted;
      case refundAnalysisStatusInfractionAPI.PARTIALLY_ACCEPTED:
        return this.partiallyAccepted;
      case refundAnalysisStatusInfractionAPI.REJECTED:
        return this.rejected;
      default:
        throw new Error('Invalid refund analysis result to convert to JDPI');
    }
  },
  convertFromJDPI(status) {
    switch (status) {
      case this.totallyAccepted:
        return refundAnalysisStatusInfractionAPI.TOTALLY_ACCEPTED;
      case this.partiallyAccepted:
        return refundAnalysisStatusInfractionAPI.PARTIALLY_ACCEPTED;
      case this.rejected:
        return refundAnalysisStatusInfractionAPI.REJECTED;
      default:
        throw new Error('Invalid refund analysis result to convert from JDPI');
    }
  }
};

module.exports = refundAnalysisResult;
